module.exports = __webpack_public_path__ + "img/gs.6adf96a8.svg";